import { render, staticRenderFns } from "./refer-coupon-tip.vue?vue&type=template&id=4593892c&scoped=true&"
import script from "./refer-coupon-tip.vue?vue&type=script&lang=js&"
export * from "./refer-coupon-tip.vue?vue&type=script&lang=js&"
import style0 from "./refer-coupon-tip.vue?vue&type=style&index=0&id=4593892c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4593892c",
  null
  
)

export default component.exports